import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceitasBrutasAnterioresComponent } from './receitas-brutas-anteriores-listar/receitas-brutas-anteriores.component';
import { SortIcon, TableModule } from 'primeng/table';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ReceitasBrutasAnterioresRoutingModule } from './receitas-brutas-anteriores-routing.module';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api'; 
import { ReceitasBrutasAnterioresEditarComponent } from './receitas-brutas-anteriores-editar/receitas-brutas-anteriores-editar.component';

@NgModule({
  declarations: [
    ReceitasBrutasAnterioresComponent,
    ReceitasBrutasAnterioresEditarComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    ToolbarModule,
    SpinnerServiceComponent,
    ReceitasBrutasAnterioresRoutingModule,
    InputTextModule,
    ButtonModule,
    PaginatorModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
  ],
  providers: [
    ConfirmationService 
  ]
})
export class ReceitasBrutasAnterioresModule { }
